import React from 'react';
import { Listbox } from '@headlessui/react';
import tw from 'twin.macro';
import { BaseButtonProps } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import {
  Props as SelectBodyProps,
  SelectBody,
} from '@teetsh/app/src/components/Form/Select2/SelectBody';
import { inputBorderStyle } from '@teetsh/app/src/components/Form/Input2';

export type Value = string | number | undefined;

export interface Props<T> {
  disabled?: boolean;
  onChange: (v: T) => void;
}

export default function Select<T extends Value>(
  props: BaseButtonProps & Omit<SelectBodyProps<T>, 'open'>,
) {
  return (
    <Listbox
      value={props.value}
      onChange={props.onChange}
      // @ts-ignore
      css={[inputBorderStyle({ error: false }), tw`hover:border-transparent`]}
      disabled={props.disabled}
    >
      {({ open }) => <SelectBody open={open} {...props} />}
    </Listbox>
  );
}
